export const addAbTest = (payload: string) => ({
  type: 'ADD_AB_TEST' as const,
  payload
});

export type AbTestAction = Partial<ReturnType<typeof addAbTest>>;
